import React from 'react';
import { Link } from 'react-router-dom';
import HomeHero from "./HomeHero";

// deleteDish is passed down through props, so can destructure it when we recieve props to prevent from call like this: props.deleteDish (added deleteDish to const Dishes({dishes, deleteDish}))
const Dishes = ({dishes, deleteDish, isAuthenticated}) => {
    return (
    <article className="posts container h-100">

        <HomeHero />

        <div className="row">
            {dishes.length < 1 && (
                <div className="col" key="empty" className="text-center">No Dishes or Recipes yet!</div>
            )}
            
            {dishes.map(dish => (
            <div key={dish.id} className="col-md-6 mb-4">

                <div className="card dish-card flex-md-row rounded-0 bg-transparent">
                    <div className="card-body d-flex flex-column align-items-start rounded-0">
                        {
                            //dish.slug is the value of what's going on
                        }
                        <h2><Link to={`/dish/${dish.slug}`}>{dish.title}</Link></h2>
                        <div className="mb-1 text-muted">{dish.date}</div>
                        <Link className="btn--details mt-auto font-weight-bold d-flex align-items-center" to={`/dish/${dish.slug}`}>
                        See Details
                        <span className="ml-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                        </span>
                       
                        </Link>
                    </div>
                    <div className="card--img--contain">
                        <img className="card-img-right flex-auto d-none d-lg-block" alt={dish.title} src={dish.imgUrl ||"https://placeimg.com/640/480/nature"}  />
                    </div>
                    
                </div>
                {isAuthenticated && (
                    <div className="d-flex justify-content-around">
                        <div className="btn--dish--edit flex-fill">
                            <Link className="btn h-100 w-100 rounded-0  d-flex align-items-center justify-content-center" to={`/edit/${dish.slug}`}>Edit 
                            <span className="ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                            </span>
                            
                            </Link>
                        </div>
                        {
                            // since we have access to dish via props it can be passed directly
                            // run deleteDish function onClick so argument of dish gets passed back to deleteDish function in App.js
                        }
                        <div className="btn--dish--edit flex-fill">
                            <button className="btn h-100 w-100 rounded-0  d-flex align-items-center justify-content-center" 
                                onClick={e => {
                                    e.preventDefault();
                                    deleteDish(dish);
                                }}>
                                Delete
                                <span className="ml-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                </span>
                                
                            </button>
                        </div>
                    </div>
                )}  
                    
            </div>
            ))}
        </div>
    </article>
    )
};

export default Dishes;